<template>
	<div>
		<van-sticky>
			<navbar :title="title" />
			<van-search v-model="form.product_name" placeholder="请输入搜索关键词" @search="onSearch"></van-search>
			<van-dropdown-menu>
				<van-dropdown-item v-model="form.purchase_status" :options="purchase_status" @change="onSearch" />
			</van-dropdown-menu>
		</van-sticky>

		<van-list v-model="list.loading" :finished="list.finished" finished-text="没有更多了" @load="onLoad" style="padding-bottom: 50px;">
			<van-cell class="item-list" v-for="item in list.list" :key="item.id" @click="reviewDetails(item.purchase_id, item.purchase_id)">
				<div class="user-title">
					<span class="user-title-name" style="font-weight: 600;">
						<van-icon name="todo-list-o" />
						{{ item.product_name }}
					</span>
					<span class="user-title-date" style="float: right;">{{ item.create_date }}</span>
				</div>
				<div>
					<van-icon name="cluster-o" />
					{{ item.supplier ? item.supplier : '未指定' }}
				</div>
				<div>
					<van-icon name="apps-o" />
					{{ item.quantity }} {{ item.unit_name }}
				</div>
				<van-tag class="item-tag" plain :type="tagPrimary[item.purchase_status].value">{{ tagPrimary[item.purchase_status].text }}</van-tag>
			</van-cell>
		</van-list>

		<van-tabbar v-model="activeName">
			<van-tabbar-item name="list" icon="clock-o" to="/purchase">采购列表</van-tabbar-item>
			<van-tabbar-item name="approval" icon="upgrade" to="/purchase/audit">我的审核</van-tabbar-item>
			<van-tabbar-item name="add" icon="add-o" to="/purchase/add">新建采购</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { Toast } from "vant";
import { post } from "@/api/post";

export default {
	components: {
		navbar,
	},
	data() {
		return {
			activeName: "list",
			title: "采购列表",
			purchase_status: [
				{ text: "采购列表", value: null },
				{ text: "采购审核", value: 0 },
				{ text: "待付款", value: 2 },
				{ text: "财务审核", value: 5 },
				{ text: "已驳回", value: 3 },
				{ text: "已办结", value: 4 },
				{ text: "董事长审核", value: 1 },
			],
			form: {
				requestType: "purchase_list_data",
				page: 1,
				limit: 10,
				purchase_status: null,
				product_name: "",
			},
			tagPrimary: [
				{ text: "采购审核", value: "default" },
				{ text: "董事长审核", value: "primary" },
				{ text: "已通过", value: "success" },
				{ text: "已驳回", value: "warning" },
				{ text: "已办结", value: "success" },
				{ text: "财务审核", value: "primary" },
			],
			list: {
				list: [],
				loading: false,
				finished: false,
			},
		};
	},
	activated() {
		if (this.$route.params.refresh != true) {
			this.list.list = [];
			this.activeName = "list";
			this.list.finished = false;
			this.form.page = 1;
			this.form.approval_status = 0;
			this.list.user_name = "";
			this.onLoad();
		}
	},
	methods: {
		activated() {
			if (!this.$route.meta.isBack || this.isFirstEnter) {
				this.onLoad();
			}
			this.$route.meta.isBack = false;
			this.isFirstEnter = false;
		},
		onSearch() {
			this.list.list = [];
			this.form.page = 1;
			this.list.finished = false;
			this.onLoad();
		},
		onLoad() {
			post(this.form)
				.then((res) => {
					if (res.obj.rows.length === 0) {
						this.list.finished = true;
					}
					if (this.form.page != 1) {
						this.list.list = this.list.list.concat(res.obj.rows);
					} else {
						this.list.list = res.obj.rows;
					}

					this.form.page += 1;
					this.list.loading = false;
				})
				.catch((err) => {
					console.log(err);
					this.list.loading = false;
					this.list.finished = true;
					return Toast.fail("数据异常");
				});
		},
		reviewDetails(type, id) {
			this.$router.push({
				path: "/purchase/details",
				query: { type: type, id: id, p: false },
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.user-title-date {
	font-size: 12px;
}

.item-list > div {
	position: relative;
	.item-tag {
		position: absolute;
		right: 5px;
		bottom: 5px;
	}
}
</style>
